var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24Live(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.928589 13.4408V4.07556H0.46875C0.209839 4.07556 0 4.2854 0 4.54431V15.4161C0 15.675 0.209839 15.8849 0.46875 15.8849H11.7117C11.9706 15.8849 12.1804 15.675 12.1804 15.4161V14.8158H2.30359C1.54541 14.8158 0.928589 14.199 0.928589 13.4408V13.4408Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91321 11.4656V2.10034H2.30347C2.04456 2.10034 1.83472 2.31018 1.83472 2.56909V13.4408C1.83472 13.6997 2.04456 13.9095 2.30347 13.9095H13.5464C13.8053 13.9095 14.0151 13.6997 14.0151 13.4408V12.8406H4.28821C3.53003 12.8406 2.91321 12.2238 2.91321 11.4656V11.4656Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73926 11.9343H15.5311C15.79 11.9343 15.9999 11.7245 15.9999 11.4656V10.0122L10.6173 5.35815L5.73926 11.9343Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28772 2.75781C6.88599 2.75781 6.55908 3.08215 6.55908 3.48083C6.55908 3.87939 6.88599 4.20374 7.28772 4.20374C7.68958 4.20374 8.01636 3.87939 8.01636 3.48083C8.01636 3.08215 7.68958 2.75781 7.28772 2.75781V2.75781Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 0.125H4.28833C4.02942 0.125 3.81958 0.334839 3.81958 0.59375V11.4656C3.81958 11.7245 4.02942 11.9343 4.28833 11.9343H4.57214L10.1641 4.39392C10.2417 4.28894 10.3596 4.22107 10.4893 4.20654C10.6189 4.19214 10.749 4.23254 10.8478 4.31799L16 8.77283V0.59375C16 0.334839 15.7902 0.125 15.5312 0.125ZM7.2876 5.14124C6.3689 5.14124 5.62146 4.39636 5.62146 3.48083C5.62146 2.56519 6.3689 1.82031 7.2876 1.82031C8.2063 1.82031 8.95374 2.56519 8.95374 3.48083C8.95374 4.39636 8.2063 5.14124 7.2876 5.14124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Live);
export default __webpack_public_path__ + "static/media/24_live.69cfbb47e27a8fa6719af63cde77545a.svg";
export { ForwardRef as ReactComponent };